import React, { Component } from "react";
// import logo from './logo.svg';
import TradeUnionList from './components/tradeunion/TradeUnionList';
import NewTradeUnion from './components/tradeunion/NewTradeUnion';
import EditTradeUnion from './components/tradeunion/EditTradeUnion';
import SectorList from './components/sector/SectorList';
import NewSector from './components/sector/NewSector';
import EditSector from './components/sector/EditSector';

import SiteList from './components/sites/SiteList';
import NewSite from './components/sites/NewSite';
import EditSite from './components/sites/EditSite';

import BranchList from './components/branch/BranchList';
import NewBranch from './components/branch/NewBranch';
import EditBranch from './components/branch/EditBranch';

import ExchangeRateList from './components/exchangerate/ExchangeRateList';
import NewExchangeRate from './components/exchangerate/NewExchangeRate';
import EditExchangeRate from './components/exchangerate/EditExchangeRate';

import GradeList from './components/grade/GradeList';
import NewGrade from './components/grade/NewGrade';
import EditGrade from './components/grade/EditGrade';
import MemberList from './components/member/MemberList';
import NewMember from './components/member/NewMember';

// Added non auth component
import NoAuthNewMember from './components/member/NoAuthNewMember';

import EditMember from './components/member/EditMember';
import BatchList from './components/accounts/BatchList';
import NewBatch from './components/accounts/NewBatch';
import ViewBatch from './components/accounts/ViewBatch';
import EditBatch from './components/accounts/EditBatch';
import InstitutionList from './components/institution/InstitutionList';
import NewInstitution from './components/institution/NewInstitution';
import EditInstitution from './components/institution/EditInstitution';
import ViewInstitution from './components/institution/ViewInstitution';
import ProcessAccount from './components/accounts/ProcessAccount';
import AccountsReport from './components/reports/AccountsReport';
import MembershipReport from './components/reports/MembershipReport';
import Login from './components/UserManagement/Login';
import Register from "./components/UserManagement/Register";
import Header from './Header';
import Home from './Home';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from "react-redux";
import store from "./store";
import './App.css';


import jwt_decode from "jwt-decode";
import setJWTToken from "./securityUtils/setJWTToken";
import { SET_CURRENT_USER } from "./actions/types";
import { logout } from "./actions/securityActions";
import SecureRoute from "./securityUtils/SecureRoute";


//Datatable Modules
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css"
// import "datatables.net-dt/js/dataTables.dataTables"
//import 'datatables.net-buttons/js/buttons.html5.js';

// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
import 'datatables.net-dt';
import 'datatables.net-buttons';
//import 'datatables.net-buttons-bs';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
// import * as JSZip from 'jszip';



const jwtToken = localStorage.jwtToken;

if (jwtToken) {
  setJWTToken(jwtToken);
  const decoded_jwtToken = jwt_decode(jwtToken);
  store.dispatch({
    type: SET_CURRENT_USER,
    payload: decoded_jwtToken
  });

  const currentTime = Date.now() / 1000;
  if (decoded_jwtToken.exp < currentTime) {
    store.dispatch(logout());
    window.location.href = "/login";
  }
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>

        <Router>
          <Header />


          <Route exact path="/login" component={Login} />
          <Route exact path="/" component={Login} />
          <Route exact path="/signup" component={Register} />

          {/* Added non auth new member */}
          <Route exact path="/new-member" component={NoAuthNewMember} />

          <Switch>
            <SecureRoute exact path="/home" component={Home} />
            <SecureRoute exact path="/add-tradeUnion" component={NewTradeUnion} />
            <SecureRoute exact path="/edit-tradeUnion/:tradeUnionId" component={EditTradeUnion} />
            <SecureRoute exact path="/tradeUnion-list" component={TradeUnionList} />
            <SecureRoute exact path="/add-sector" component={NewSector} />
            <SecureRoute exact path="/edit-sector/:sectorId" component={EditSector} />
            <SecureRoute exact path="/sector-list" component={SectorList} />

            <SecureRoute exact path="/add-site" component={NewSite} />
            <SecureRoute exact path="/edit-site/:siteId" component={EditSite} />
            <SecureRoute exact path="/site-list" component={SiteList} />


            <SecureRoute exact path="/add-branch" component={NewBranch} />
            <SecureRoute exact path="/edit-branch/:branchId" component={EditBranch} />

            <SecureRoute exact path="/add-exchangeRate" component={NewExchangeRate} />
            <SecureRoute exact path="/edit-exchangeRate/:exchangeRateId" component={EditExchangeRate} />

            <SecureRoute exact path="/branch-list" component={BranchList} />
            <SecureRoute exact path="/exchangeRate-list" component={ExchangeRateList} />
            <SecureRoute exact path="/add-grade" component={NewGrade} />
            <SecureRoute exact path="/edit-grade/:gradeId" component={EditGrade} />
            <SecureRoute exact path="/grade-list" component={GradeList} />
            <SecureRoute exact path="/add-member" component={NewMember} />
            <SecureRoute exact path="/edit-member/:memberId" component={EditMember} />
            <SecureRoute exact path="/member-list" component={MemberList} />
            <SecureRoute exact path="/add-institution" component={NewInstitution} />
            <SecureRoute exact path="/edit-institution/:institutionId" component={EditInstitution} />
            <SecureRoute exact path="/view-institution/:institutionId" component={ViewInstitution} />
            <SecureRoute exact path="/institution-list" component={InstitutionList} />
            <SecureRoute exact path="/add-batch" component={NewBatch} />
            <SecureRoute exact path="/edit-batch/:batchId" component={EditBatch} />
            <SecureRoute exact path="/batch-list" component={BatchList} />
            <SecureRoute exact path="/view-batch/:batchId" component={ViewBatch} />
            <SecureRoute exact path="/process-account/" component={ProcessAccount} />
            <SecureRoute exact path="/accounts-report/" component={AccountsReport} />
            <SecureRoute exact path="/membership-report/" component={MembershipReport} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default App;
